import { Helmet } from 'react-helmet-async';

interface PageHeadProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  robots?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  keywords?: string;
}

export default function PageHead({
  title = 'Title',
  description = 'meta_description',
  canonicalUrl,
  robots,
  ogTitle,
  ogDescription,
  ogImage,
  keywords
}: PageHeadProps) {
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;

  return (
    <Helmet>
      <title>{title} | HSDesk</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {robots && <meta name="robots" content={robots} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {resolvedOgTitle && (
        <meta property="og:title" content={resolvedOgTitle} />
      )}
      {resolvedOgDescription && (
        <meta property="og:description" content={resolvedOgDescription} />
      )}
      {ogImage && <meta property="og:image" content={ogImage} />}
    </Helmet>
  );
}
